import { useTranslation } from 'react-i18next'

import { Alert, Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeleteShippingMethodModal = ({ show, onClose, onDelete, shippingMethod }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Eliminar método de envío')} size="l">
      <Styles.Container>
        <Text type="bodyMRegular">{t('Esta acción no se podrá deshacer. ¿Quieres continuar?')}</Text>
        {shippingMethod?.carrier?.is_connected && (
          <Alert type="warning">
            {t(
              'Este método tiene activada la conexión con el transportista para la creación automática de etiquetas de envio.'
            )}
          </Alert>
        )}
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <Button fullWidth onClick={onDelete}>
            {t('Aceptar')}
          </Button>
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default DeleteShippingMethodModal
